/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Editorial_Alternatives_DescInputs */

const en_directory_detail_editorial_alternatives_desc = /** @type {(inputs: Directory_Detail_Editorial_Alternatives_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These tools were linked as editorial alternatives with a documented reason for the relationship.`)
};

const zh_directory_detail_editorial_alternatives_desc = /** @type {(inputs: Directory_Detail_Editorial_Alternatives_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这些工具以带有明确编辑理由的替代关系关联到当前产品。`)
};

/**
* | output |
* | --- |
* | "These tools were linked as editorial alternatives with a documented reason for the relationship." |
*
* @param {Directory_Detail_Editorial_Alternatives_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_editorial_alternatives_desc = /** @type {((inputs?: Directory_Detail_Editorial_Alternatives_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Editorial_Alternatives_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_editorial_alternatives_desc(inputs)
	return zh_directory_detail_editorial_alternatives_desc(inputs)
});
export { directory_detail_editorial_alternatives_desc as "directory.detail.editorial_alternatives_desc" }